import { Helmet } from "react-helmet";

const SEOHelmet = () => (
  <Helmet>
    {/* Canonical Tag */}
    <link rel="canonical" href="https://aiginroyalsales.com/" />

    {/* Title */}
    <title>
      AIGIN Royal | 2 & 3 BHK Apartments in Sector 1, Greater Noida West
    </title>

    {/* Meta Description */}
    <meta
      name="description"
      content="Book your ready-to-move 2 & 3 BHK apartment at AIGIN Royal, Sector 1, Greater Noida West. Modern amenities, landscaped open spaces, kids play area & 24x7 security. Call +919555768358."
    />

    {/* Meta Keywords */}
    <meta
      name="keywords"
      content="AIGIN Royal, Sector 1 Greater Noida West, AIGIN Group, 2 BHK apartments Greater Noida West, 3 BHK flats Noida Extension, ready-to-move apartments Noida, real estate Greater Noida, book site visit AIGIN Royal, premium amenities Noida, property in Sector 1 Greater Noida West, floor plan AIGIN Royal, affordable flats Noida"
    />

    {/* Open Graph (for social sharing) */}
    <meta
      property="og:title"
      content="AIGIN Royal - 2 & 3 BHK Apartments in Greater Noida West"
    />
    <meta
      property="og:description"
      content="Explore ready-to-move 2 & 3 BHK apartments at AIGIN Royal, Sector 1, Greater Noida West. Enjoy modern amenities, landscaped gardens, kids play area, and 24x7 security."
    />
    <meta property="og:image" content="%PUBLIC_URL%/ico.webp" />
    <meta property="og:url" content="https://aiginroyalsales.com/" />
    <meta property="og:type" content="website" />

    {/* Mobile Meta */}
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Helmet>
);

export default SEOHelmet;
